module.exports = __webpack_public_path__ + "img/top.a8b1d6a5.png";